// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world
import wixData from 'wix-data';
import wixWindow from 'wix-window';
import wixUsers from 'wix-users';
import wixLocation from 'wix-location';
let user = wixUsers.currentUser;
let userId = user.id; 
let postid
let posttitle
let hashtags
let dateofissue
let linkofnext
let linkofprevious


$w.onReady(function () {
	
$w("#post1").getPost()
  .then( (post) => {
	  postid = post._id
	  posttitle = post.title
	hashtags = post.hashtags
if (hashtags.indexOf("新時代香港大事紀") !== -1) {
  $w("#columnStrip5").expand()
  $w("#columnStrip8").expand()
readdateofissue()
} else {
  $w("#columnStrip5").collapse()
  $w("#columnStrip8").collapse()
  $w("#gallery4").items = [{ "type": "image", "src": post.coverImage}]
  }
  } )

})

function readdateofissue() {
	wixData.query("hongkonghistory")
	.contains("title", posttitle)
	.limit(1)
  .find()
  .then( (results) => {
    if(results.items.length > 0) {
      dateofissue = results.items[0].dateofissue
      if(wixWindow.formFactor !== "Mobile") {
      $w("#gallery4").items = [{ "type": "image", "src": results.items[0].cover}]} else {$w("#gallery4").collapse()}
      }
      readprevious()
    }) 
}

function readprevious() {
  wixData.query("hongkonghistory")
	.lt("dateofissue", dateofissue)
  .descending("dateofissue")
	.limit(1)
  .find()
  .then( (results) => {
    if(results.items.length > 0) {
      $w("#text75").text = results.items[0].title
      $w("#image14").src = results.items[0].cover
      $w("#button7").link = results.items[0].link
      $w("#button7").target = "_blank"
      readnext()
    }  else {
      $w("#column13").collapse()} 
      readnext()})
}

function readnext() {
  wixData.query("hongkonghistory")
	.gt("dateofissue", dateofissue)
  .ascending("dateofissue")
	.limit(1)
  .find()
  .then( (results) => {
    if(results.items.length > 0) {
      $w("#text76").text =  results.items[0].title
      $w("#image15").src = results.items[0].cover
      $w("#button8").link = results.items[0].link
      $w("#button8").target = "_blank"
      $w("#columnStrip5").expand()
    }  else {
      $w("#text76").hide()
      $w("#text77").hide()
      $w("#image15").hide()
      $w("#column14").collapse()
       $w("#columnStrip5").expand()
      } })
}
